module.exports = __webpack_public_path__ + "img/40_15.2a05a306.png";